module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project !== null) ? _c('div', {
    attrs: {
      "id": "project-detail"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "controls pull-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLess),
      expression: "hasLess"
    }],
    staticClass: "chev left",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMore),
      expression: "hasMore"
    }],
    staticClass: "chev right",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 project-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "project-info"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-7"
  }, _vm._l((_vm.project.src), function(src) {
    return _c('img', {
      staticClass: "project-img img-responsive",
      attrs: {
        "src": _vm.imageSrc(src)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('h3', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), (_vm.hasDescription) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.body)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', [(_vm.hasClient) ? _c('li', [_c('strong', [_vm._v("Client")]), _vm._v(": " + _vm._s(_vm.project.client))]) : _vm._e(), _vm._v(" "), (_vm.hasUrl) ? _c('li', [_c('strong', [_vm._v("URL")]), _vm._v(":\n                    "), _c('a', {
    attrs: {
      "href": _vm.project.website
    }
  }, [_vm._v("View Project")])]) : _vm._e(), _vm._v(" "), (_vm.hasMultipleBullets) ? _c('ul', {
    staticClass: "bullet-list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.project.bullets), function(bullet) {
    return _c('li', {
      staticClass: "bullet"
    }, [_vm._v(_vm._s(bullet))])
  })], 2) : _c('li', [_vm._v(_vm._s(_vm.project.bullets[0]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "related"
  }, [_c('h2', [_vm._v("related works")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.related), function(project) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('project-preview', {
      attrs: {
        "project": project
      }
    })], 1)
  }))])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Our Services:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0533039a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProjectDetail.vue
// module id = 582
// module chunks = 2